import global from './global'

function index() {
  global()
}

export default index
